export const SALES_TYPE = 'sales'
export const RENTALS_TYPE = 'rentals'
export const LANDS_TYPE = 'lands'
export const SALES_VALUE_SCOPE = 'search_sale'
export const SALES_SEARCH_URL = '/search_sales'
export const RENTALS_VALUE_SCOPE = 'search_rental'
export const RENTALS_SEARCH_URL = '/search_rentals'
export const DIRECTION = { NEXT: 1, PREV: -1 }
